import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_17o2s1dixa: FaireBrandEntity = {
  token: "b_17o2s1dixa",
  type: "brand",
  name: "American Hat Makers",
  avatarUrl: "https://cdn.faire.com/fastly/4fd8ed7f75e89b5d120bd78aa33382d5ccff1080cb7354e9d23b753a2e185403.png",
  bannerUrl: "https://cdn.faire.com/fastly/0a1ff69bf87c9ad268b463040ad664ec3ab2d06f725a2c22323cb637ca012927.png",
  logoUrl: "https://cdn.faire.com/fastly/4fd8ed7f75e89b5d120bd78aa33382d5ccff1080cb7354e9d23b753a2e185403.png",
  heroImageUrl: "https://cdn.faire.com/fastly/0a1ff69bf87c9ad268b463040ad664ec3ab2d06f725a2c22323cb637ca012927.png",
  location: "Emory, TX, USA",
  minimumOrderDollars: 150,
  rating: 4.8,
  reviewCount: 683,
  isTopShop: true,
  isInsider: true,
  description: "For over half a century, American Hat Makers has been at the forefront of creating unique, luxurious artisan hats. Beginning in 1972 with Gary Watrous selling his handmade leather goods, our journey has evolved from a small ranch operation to a global pursuit. Now based in Emory, Texas, we traverse the world to curate the finest hats for our discerning clientele.\n\nUnder Garth Watrous’ leadership, we've reached new heights, with Hannah steering our global marketing to establish a strong international presence. At American Hat Makers, our legacy of craftsmanship continues to thrive, as we bring you an unparalleled selection of headwear, each backed by a 50-year guarantee. Committed to excellence, we offer an eclectic mix of traditional and modern designs, ensuring every hat is a testament to our dedication to quality.",
  meta: {
    source: "api",
    importedAt: "2026-10-12T19:14:02.521Z",
    importedBy: "entity-db-cli"
  }
};
